// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialMedia_container__FFjlH","title":"SocialMedia_title__cGNv4","linksContainer":"SocialMedia_linksContainer__ESrU2","icon":"SocialMedia_icon__qgeuI"};